/** vuex 触发sidebar状态变化 */
export const VUEX_ACTIONS_SIDEBAR_TOGGLE = `vuex_actions_sidebar_toggle`;
export const VUEX_MUTATIONS_SIDEBAR_TOGGLE = `vuex_mutations_sidebar_toggle`;

/** 获取所有路由和导航数据 */
export const VUEX_ACTIONS_ROUTER_GET_ALL = `vuex_actions_router_get_all`;
export const VUEX_MUTATIONS_ROUTER_GET_ALL = `vuex_mutations_router_get_all`;

/** 当前登录用户 */
export const VUEX_ACTIONS_USER_INFO = `vuex_actions_user_info`;
export const VUEX_MUTATIONS_USER_INFO = `vuex_mutations_user_info`;

// 多页签组件
/** 将选择的导航加入到全局缓存中 */
export const VUEX_ACTIONS_TAGS_VIEW_ADD = `vuex_actions_tags_view_add`;
/** 在全局缓存中删除路由信息 */
export const VUEX_ACTIONS_TAGS_VIEW_DELETE = `vuex_actions_tags_view_delete`;
/** 在全局缓存中删除路由信息，并保留选择的页卡 */
export const VUEX_ACTIONS_TAGS_VIEW_DELETE_OTHER = `vuex_actions_tags_view_delete_other`;

export const VUEX_MUTATIONS_TAGS_VIEW_ADD = `vuex_mutations_tags_view_add`;
export const VUEX_MUTATIONS_TAGS_VIEW_DELETE = `vuex_mutations_tags_view_delete`;
export const VUEX_MUTATIONS_TAGS_VIEW_DELETE_OTHER = `vuex_mutations_tags_view_delete_other`;

export const KEY_USER_STORAGE = `KEY_USER_STORAGE`;
export const KEY_SESSION_STORAGE = `KEY_SESSION_STORAGE`;
export const KEY_LEARNING_LESSON_ID = `KEY_SESSION_STORAGE`;

export const VUEX_ACTIONS_KEY_MENU_INDEX = `vuex_actions_key_menu_index`;

//菜单未读消息数
export const VUEX_MUTATIONS_REMIND_NUM = `vuex_mutations_remind_num`;
export const VUEX_ACTIONS_REMIND_NUM = `vuex_actions_remind_num`;
export const VUEX_REMIND_NUM_DATA =  {
           todoList:[//待办事项
             {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'待办任务'},//待办任务
             {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'考勤申诉'},//考勤申诉
             {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'待我审批'},//待我审批
             {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'档案审核'}//档案审核
           ],
           myApply:[//我申请的
              {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'申请中'}//申请中
           ],
           myApprove:[//我审批的
               {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'待审批'}//待审批
           ],
           myCarbonCopy:[//抄送我的
               {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'抄送我的'}//抄送我的
           ],
           myInvolved:[//我参与的
               {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'我参与的-流程数'},//我参与的
               {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'我参与的-任务数'}//我参与的
           ],
           cronjobNotice:[//定时通知
               {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'定时通知'}//定时通知
           ],
           warningNotice:[//预警消息
               {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'预警消息'}//预警消息
           ],
           messageNotice:[//消息公告
               {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'消息数'},//消息数
               {num:0,bgColor:'red',fontColor:'#FFFFFF',title:'公告数'}//公告数
           ]
    };
//页签未读消息角标
export const VUEX_NAV_NUM_DATA={
	needWorkingTask:0,//待办任务
	myApprove:0//待我审批
};
export const VUEX_MUTATIONS_NAV_NUM_DATA = `vuex_mutations_nav_num_data`;
export const VUEX_ACTIONS_NAV_NUM_DATA = `vuex_actions_nav_num_data`;
//工作台快捷入口
export const VUEX_WORK_PLANT_ENTRY=[
    {
        path: '/workspace/needWorkingTask',
        component: () => import('@/pages/workbench/NeedWorkingTask'),
        isShow: false,
        isEntry: false,
        name: 'needWorkingTask',
        id: 'workspace/needWorkingTask',
        meta: {
            title: '待办任务',
            icon: 'iconfont icon-other-daibanshixiang bc-custom-menu',
            color:'#1296db'
        },
        query:{},
        params:{}
    }
    // ,{
    //     path: '/workspace/myApprove',
    //     component: () => import('@/pages/workbench/MyApprove'),
    //     // redirect: 'noredirect',
    //     isShow: false,
    //     isEntry: true,
    //     name: 'myApprove',
    //     id: 'workspace/myApprove',
    //     meta: {
    //         title: '我审批的',
    //         icon: 'iconfont icon-other-woshenpide bc-custom-menu',
    //         color:'#f4ea2a'
    //     },
    //     query:{},
    //     params:{}
    // }
];
export const VUEX_MUTATIONS_WORK_PLANT_ENTRY = `vuex_mutations_work_plant_entry`;
export const VUEX_ACTIONS_WORK_PLANT_ENTRY = `vuex_actions_work_plant_entry`;
//导航栏是否展现左侧菜单
export const VUEX_NAV_SHOW_LEFT='hidden';//hidden隐藏菜单show展示菜单
export const VUEX_MUTATIONS_NAV_SHOW_LEFT = `vuex_mutations_nav_show_left`;
export const VUEX_ACTIONS_NAV_SHOW_LEFT = `vuex_actions_nav_show_left`;
//新版老版状态标示
export const VUEX_LAYOUT_TYPE='new';//new新版old老版
export const VUEX_MUTATIONS_LAYOUT_TYPE = `vuex_mutations_layout_type`;
export const VUEX_ACTIONS_LAYOUT_TYPE = `vuex_actions_layout_type`;



// WEBPACK FOOTER //
// ./src/common/constants/const-vuex.js